
import BaseArticleTeaserWidget from '../../../../base/components/sidebar/widgets/ArticleTeaserWidget.vue'

export default class ArticleTeaserWidget extends BaseArticleTeaserWidget {}
